export default "__VITE_ASSET__DfmqRXHL__"